import { Component, signal, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { SousTraitantService } from '../../../core/services/sous-traitant.service';
import { SousTraitant } from '../../../core/models/models';

@Component({
  selector: 'app-sous-traitant-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    FormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule
  ],
  templateUrl: `./sous-traitant-list.component.html`,
  styleUrls: [`./sous-traitant-list.component.css`]
})
export class SousTraitantListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  stService = inject(SousTraitantService);
  private router = inject(Router);

  sousTraitants = signal<SousTraitant[]>([]);
  totalElements = signal(0);
  page = signal(0);
  size = signal(10);
  searchQuery = '';
  sortField = 'denomination';
  sortDirection = 'asc';
  showArchived = signal(false);

  private searchSubject = new Subject<string>();

  ngOnInit() {
    this.loadSousTraitants();

    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(query => {
      this.searchQuery = query;
      this.page.set(0);
      this.loadSousTraitants();
    });
  }

  loadSousTraitants() {
    const sortParam = `${this.sortField},${this.sortDirection}`;
    this.stService.getSousTraitants(this.searchQuery, this.page(), this.size(), sortParam, this.showArchived()).subscribe(response => {
      this.sousTraitants.set(response.content);
      this.totalElements.set(response.totalElements);
    });
  }

  onSearchChange(value: string) {
    this.searchSubject.next(value);
  }

  onSortChange(sortState: Sort) {
    this.sortField = sortState.active;
    this.sortDirection = sortState.direction || 'asc';
    this.page.set(0);
    this.loadSousTraitants();
  }

  onToggleArchived() {
    this.showArchived.update(v => !v);
    this.page.set(0);
    this.loadSousTraitants();
  }

  onPageChange(event: PageEvent) {
    this.page.set(event.pageIndex);
    this.size.set(event.pageSize);
    this.loadSousTraitants();
  }

  onEdit(st: SousTraitant) {
    this.router.navigate(['/sous-traitants/edit', st.id]);
  }
}
